import {get} from 'lodash/fp';
import {createSelector} from 'reselect';

import {autoLogin as getAutoLoginState} from './root.selector';

export const autoLoginState = createSelector(
  getAutoLoginState,
  get('autoLoginBiometrics'),
);
